import { tab } from "@testing-library/user-event/dist/tab";
import { Breadcrumb, Button, Card, Flex, Row, Space } from "antd";
import MainLayout from "components/layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";

const ProductManagement = ({
    headPart = "",
    // firstRow = () => { },
    // table = () => { },
    // EditPage = () => { },
    onCreate = () => { },
    getPage = () => { },
    state = {}
}) => {
    const { t, i18n } = useTranslation();

    return (
        <MainLayout title={t('product.header')}>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Row justify="space-between">
                    <div>
                        <Breadcrumb items={[
                            { title: t("home.header"), link: "/" },
                            { title: t('configuration.entity') },
                            { title: t('product.header'), link: "/configuration/product" },
                        ]}
                        />
                        <h2> {t('product.detail')}</h2>
                    </div>

                    <Space size={12}>

                        {
                            state.page == 'table' &&
                            <>
                                <Button type="default" onClick={() => {
                                    //  setUseFilter(!useFilter) 
                                }} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
                                    <Flex align="center" justify="center" gap={8}>
                                        <FilterIcon />
                                        <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                                    </Flex>
                                </Button>
                                <Button onClick={(e) => { onCreate(); }}
                                    style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                                    type="primary">
                                    <Flex align="center" justify="center" gap={8}>
                                        <CreateIcon />
                                        <span>{t('common.create')}</span>
                                    </Flex>
                                </Button>
                            </>
                        }


                    </Space>
                </Row>
                {/* <Card style={{ height: "100%" }}> */}
                <Flex vertical>
                    {getPage()}
                    {/* {table()}
                    {EditPage()} */}
                </Flex>
                {/* </Card> */}
            </Space>
        </MainLayout>
    )
}

export default ProductManagement;
